import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Loading/loader-alt.svg");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Loading/Loading.module.scss")